import React, { useEffect, useMemo, useState } from 'react';

import { CtaButton } from '../../shared-components/CtaButton/CtaButton';
import { Checkbox } from '../../shared-components/Checkbox/Checkbox';
import { OrganizationSetting } from '../../types';

import TextAreaCount from '../../shared-components/TextAreaCount/TextAreaCount';
import styles from './PEBannerControls.module.css';
import { actions, thunk, useAppDispatch, useAppSelector } from 'redux-stores';

export const PEBannerControls = () => {
  const dispatch = useAppDispatch();
  const { peBanner = '' } = useAppSelector((state) => ({
    peBanner: state.orgSettings.settings.peBanner,
  }));

  const [initialText, setInitialText] = useState<string>(peBanner);
  const [textBuffer, setTextBuffer] = useState<string>(peBanner);

  useEffect(() => {
    // Sync local buffers when store changes externally
    setTextBuffer(peBanner);
    setInitialText(peBanner);
  }, [peBanner]);

  const isDirty = useMemo(() => textBuffer !== initialText, [textBuffer, initialText]);

  const handleCancel = () => {
    setTextBuffer(initialText);
    dispatch(
      actions.updateSettings({
        peBanner: initialText,
      } as unknown as OrganizationSetting)
    );
  };

  const handleSave = async () => {
    dispatch(
      actions.updateSettings({
        peBanner: textBuffer.trim(),
      } as unknown as OrganizationSetting)
    );
    thunk.saveSettings({ dispatch }).then(() => {
      setInitialText(textBuffer);
    });
  };

  const isEnabled = peBanner !== '';

  const handleCheckboxToggle = () => {
    const newValue = isEnabled ? '' : textBuffer || ' ';
    dispatch(
      actions.updateSettings({
        peBanner: newValue,
      } as unknown as OrganizationSetting)
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.checkboxWrapper}>
        <Checkbox
          checked={isEnabled}
          dataTestId="peBannerCheckbox"
          onClick={handleCheckboxToggle}
        />
      </div>
      {isEnabled && (
        <div className={styles.inputWrapper}>
          <div>
            <TextAreaCount
              lengthLimit={300}
              labelText={'Patient Banner Message:'}
              value={textBuffer}
              onTextAreaChange={(e) => setTextBuffer(e.target.value)}
              dataTestId={'patientBannerMessage'}
            />
          </div>
        </div>
      )}
      {isDirty && (
        <div className={styles.buttonsWrapper}>
          <CtaButton label={'Cancel'} onClick={handleCancel} />
          <CtaButton label={'Save'} primary onClick={handleSave} />
        </div>
      )}
    </div>
  );
};
